export const defaultCountryCode = {
  code : ['ug', 'in']
};
